import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalculationResponse } from '../../../../../../../../common/dist/angular/responses/calculation.response';
import { ExportManager } from '../../managers/export.manager';
import { ViewStateEnum } from '../../../core/enums/view-state.enum';
import { ExportTypeEnum } from '../../../../../../../../common/src/enums/export-type.enum';
import { Component } from '@angular/core';

@Component({
  template: '',
  standalone: false,
})
export abstract class ExportModalBase {
  public calculationResponse?: CalculationResponse;

  public exportState: ViewStateEnum = ViewStateEnum.Ready;

  public ExportType = ExportTypeEnum;

  public error: string;

  constructor(
    public readonly activeModal: NgbActiveModal,
    public readonly exportManager: ExportManager,
  ) {
  }

  async close() {
    this.activeModal.close();
  }

  async exportPdf() {
    if (!this.calculationResponse) {
      return;
    }
    await this.exportManager.exportPdf(this.calculationResponse);
  }

  async exportExcel() {
    if (!this.calculationResponse) {
      return;
    }
    await this.exportManager.exportExcel(this.calculationResponse);
  }
}